import { useEffect, useState } from "react";
import PavilionTable from "./PavilionTable";
import PavilionForm from "./PavilionForm";
import Modal from "components/common/Modal";
import { usePavilions } from "./hooks/usePavilions";
import { useOrganizers } from "components/company/hooks/useOrganizers";
import Alert from "components/common/Alert";

export default function PavilionContainer() {
  const {
    data,
    loading,
    loadPavilions,
    loadPavilionById,
    addPavilion,
    editPavilion,
    deletePavilion,
  } = usePavilions();

  const [openAdd, setOpenAdd] = useState(false);
  const [editing, setEditing] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  const userId = localStorage.getItem("user_id") || "69579c6190a653b640e65639";

  useEffect(() => {
    if (selectedOrganizer) {
      loadPavilions(selectedOrganizer);
    }
  }, [selectedOrganizer]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  return (
    <>
      <div className="mb-4 flex justify-end">
        <button
          className="rounded bg-blue-600 px-4 py-2 text-white"
          onClick={() => setOpenAdd(true)}
        >
          + Add Pavilion
        </button>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}

      <PavilionTable
        data={data}
        loading={loading}
        onEdit={setEditing}
        onDelete={async (row) => {
          try {
            const res = await deletePavilion(row._id, {
              is_deleted: true,
              deleted_by: userId,
            });
            setAlert({
              type: "success",
              message: "Pavilion deleted successfully",
            });
            loadPavilions(selectedOrganizer);
          } catch (error) {
            setAlert({
              type: "error",
              message: error.response?.data?.message || "Something went wrong while deleting pavilion",
            });
          }
        }}
      />

      <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
        <PavilionForm
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload) => {
            try {
              await addPavilion({
                ...payload,
                created_by: userId,
                updated_by: userId,
              });
              setAlert({
                type: "success",
                message: "Pavilion created successfully",
              });
              setOpenAdd(false);
              loadPavilions(selectedOrganizer);
            } catch (error) {
              setAlert({
                type: "error",
                message: error.response?.data?.message || "Something went wrong while creating pavilion",
              });
            }
          }}
        />
      </Modal>

      <Modal open={!!editing} onClose={() => setEditing(null)}>
        {editLoading ? (
          <p className="p-4 text-center">Loading...</p>
        ) : (
          <PavilionForm
            initialData={editing}
            onClose={() => setEditing(null)}
            onSubmit={async (payload) => {
              try {
                await editPavilion(editing._id, {
                  ...payload,
                  updated_by: userId,
                });
                setAlert({
                  type: "success",
                  message: "Pavilion updated successfully",
                });
                setEditing(null);
                loadPavilions(selectedOrganizer);
              } catch (error) {
                setAlert({
                  type: "error",
                  message: error.response?.data?.message || "Something went wrong while updating pavilion",
                });
              }
            }}
          />
        )}
      </Modal>
    </>
  );
}